import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/remove_white.svg'
import _imports_1 from '@/assets/img/detail_white.svg'


const _hoisted_1 = { class: "productData" }
const _hoisted_2 = { class: "productDataLine" }
const _hoisted_3 = { class: "productDataLine" }
const _hoisted_4 = { class: "text-black" }
const _hoisted_5 = { class: "productDataLine" }
const _hoisted_6 = { class: "text-black" }
const _hoisted_7 = { class: "productDataLine" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "imageVelo" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (!_ctx.selected)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["productUrlCard", { selected: _ctx.selected }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.select && _ctx.select(...args)))
      }, [
        _createElementVNode("div", {
          class: "image",
          style: _normalizeStyle(_ctx.itemStyle)
        }, null, 4),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_localized_text, {
              class: "text-gray",
              localizedKey: "Collezione",
              text: "Collezione"
            }),
            _createVNode(_component_localized_text, {
              class: "text-black",
              localizedKey: _ctx.item.collezione,
              text: _ctx.item.collezione
            }, null, 8, ["localizedKey", "text"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_localized_text, {
              class: "text-gray",
              localizedKey: "Nome",
              text: "Nome"
            }),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$filters.localize(_ctx.item.localizedName)), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_localized_text, {
              class: "text-gray",
              localizedKey: "Prezzo",
              text: "Prezzo"
            }),
            _createElementVNode("span", _hoisted_6, "€ " + _toDisplayString(_ctx.$filters.currency(_ctx.item.prezzo)), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_localized_text, {
              class: "text-gray",
              localizedKey: "Disponibile",
              text: "Disponibile"
            }),
            (!!_ctx.item.available)
              ? (_openBlock(), _createBlock(_component_localized_text, {
                  key: 0,
                  class: "text-black",
                  localizedKey: "Si",
                  text: "Si"
                }))
              : (_openBlock(), _createBlock(_component_localized_text, {
                  key: 1,
                  class: "text-red",
                  localizedKey: "Esaurito",
                  text: "Esaurito"
                }))
          ])
        ])
      ], 2))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["productUrlCard", { selected: _ctx.selected }])
      }, [
        _createElementVNode("div", {
          class: "image",
          style: _normalizeStyle(_ctx.itemStyle)
        }, null, 4),
        _hoisted_8,
        _createElementVNode("div", {
          class: "left pointer",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args)))
        }, [
          _hoisted_9,
          _createVNode(_component_localized_text, {
            localizedKey: "Rimuovi",
            text: "Rimuovi"
          })
        ]),
        _hoisted_10,
        _createElementVNode("div", {
          class: "right pointer",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.details && _ctx.details(...args)))
        }, [
          _hoisted_11,
          _createVNode(_component_localized_text, {
            localizedKey: "Dettaglio",
            text: "Dettaglio"
          })
        ])
      ], 2))
}